import { render, staticRenderFns } from "./BehaviorsConf.vue?vue&type=template&id=b5e7ce30"
import script from "./BehaviorsConf.vue?vue&type=script&lang=js"
export * from "./BehaviorsConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports